import { createContext } from "react";

export const PopupsContext = createContext();
